import type { ReactNode } from 'react';

export const symbol_curtains_closed: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M160-180v-600q0-24.75 17.63-42.38Q195.25-840 220-840h520q24.75 0 42.38 17.62Q800-804.75 800-780v600h50q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H110q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-180 110-180h50Zm60 0h145v-600H220v600Zm205 0h110v-600H425v600Zm170 0h145v-600H595v600Zm-375 0v-600 600Zm520 0v-600 600Z"
		/>
	</svg>
);
